import React, { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import styles from "../LandingPage.module.css";
import { Typography, Box } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useBreakpoints } from "../ResponsiveBreapoints";
import { blogPosts } from "./blogData";

const BlogDetail = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { IsXS } = useBreakpoints();

    const post = blogPosts.find((p) => p.slug === slug);

    useEffect(() => {
        if (post) {
            document.title = `${post.title} | JP Capital`;

            // Basic meta tags for social sharing
            const metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute("content", post.description);
            }

            // Add Open Graph tags dynamically
            const ogTitle = document.querySelector('meta[property="og:title"]') || document.createElement('meta');
            ogTitle.setAttribute('property', 'og:title');
            ogTitle.setAttribute('content', post.title);
            document.head.appendChild(ogTitle);

            const ogDesc = document.querySelector('meta[property="og:description"]') || document.createElement('meta');
            ogDesc.setAttribute('property', 'og:description');
            ogDesc.setAttribute('content', post.description);
            document.head.appendChild(ogDesc);
        }
    }, [post]);

    if (!post) {
        return (
            <Grid container justifyContent="center" sx={{ py: 10 }}>
                <Typography variant="h5">Blog Post Not Found</Typography>
                <Typography
                    sx={{ cursor: 'pointer', color: '#2a75bb', mt: 2 }}
                    onClick={() => navigate('/blogs')}
                >
                    Back to Blogs
                </Typography>
            </Grid>
        );
    }

    return (
        <Grid container justifyContent="center">
            <Grid
                size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7, xxl: 5 }}
                className={styles.contactContainer}
                ml={IsXS ? "" : 3}
            >
                <Grid container rowSpacing={4}>
                    <Grid size={12}>
                        <Typography
                            sx={{
                                color: '#2a75bb',
                                fontFamily: "Inter-600",
                                fontSize: '14px',
                                cursor: 'pointer',
                                mb: 2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                            onClick={() => navigate('/blogs')}
                        >
                            ← Back to Blogs
                        </Typography>
                        <Typography
                            sx={{
                                color: '#2a75bb',
                                fontFamily: "Montserrat-600",
                                fontSize: '14px',
                                letterSpacing: '1px',
                                mb: 1
                            }}
                        >
                            {post.category} • {post.date}
                        </Typography>
                        <Typography
                            className={styles.aboutUsHeading}
                            sx={{
                                fontSize: { xs: '28px', md: '36px' },
                                lineHeight: 1.2,
                                color: '#1e1e1e !important',
                                mb: 4
                            }}
                        >
                            {post.title}
                        </Typography>

                        {post.image && (
                            <Box
                                component="img"
                                src={post.image}
                                alt={post.title}
                                sx={{
                                    width: '100%',
                                    height: { xs: '250px', md: '500px' },
                                    objectFit: 'cover',
                                    borderRadius: '15px',
                                    mb: 4
                                }}
                            />
                        )}
                    </Grid>

                    <Grid size={12}>
                        <Box
                            className={styles.aboutUsDescription}
                            sx={{
                                fontSize: '16px',
                                lineHeight: 1.8,
                                '& h3': {
                                    color: '#2a75bb',
                                    fontFamily: 'Montserrat-600',
                                    mt: 4,
                                    mb: 2
                                },
                                '& p': { mb: 3 }
                            }}
                            dangerouslySetInnerHTML={{ __html: post.content }}
                        />
                    </Grid>

                    <Grid size={12} sx={{ mt: 4, pt: 4, borderTop: '1px solid #eee' }}>
                        <Typography className={styles.aboutUsTitle} sx={{ mb: 2 }}>
                            SHARE THIS ARTICLE
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {/* Simple share buttons would go here */}
                            <Typography
                                sx={{
                                    color: '#2a75bb',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontFamily: 'Inter-500',
                                    '&:hover': { textDecoration: 'underline' }
                                }}
                                onClick={() => {
                                    navigator.clipboard.writeText(window.location.href);
                                    alert('Link copied to clipboard!');
                                }}
                            >
                                Copy Link
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default BlogDetail;
